var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5953",
    "data-name": "Group 5953",
    transform: "translate(-14788.469 -21453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5933",
    "data-name": "Group 5933",
    transform: "translate(14788.469 21453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5912",
    "data-name": "Path 5912",
    d: "M252.466,176.96h-4.8a.714.714,0,0,0-.709.709v4.8a.714.714,0,0,0,.709.709h4.8a.714.714,0,0,0,.709-.709v-4.8a.714.714,0,0,0-.709-.709Z",
    transform: "translate(-242.068 -172.068)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5913",
    "data-name": "Path 5913",
    d: "M92,14a8,8,0,1,0,8,8A8.007,8.007,0,0,0,92,14Zm0,14.754A6.754,6.754,0,1,1,98.754,22,6.764,6.764,0,0,1,92,28.754Z",
    transform: "translate(-84 -14)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.1d42c0e30e14a542ba902d4e17272c13.svg";
export { ForwardRef as ReactComponent };